import React, { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import Camera from 'react-html5-camera-photo';
import LocalFileImage from 'src/components/base/localFileImage';
import { dataURItoBlob } from 'src/util';
import without from 'lodash/without';
import { v4 as uuid } from 'uuid';

import 'react-html5-camera-photo/build/css/index.css';

import Upload from 'src/assets/icons/file_upload.svg';
import CameraIcon from 'src/assets/icons/local_see.svg';
import File from 'src/assets/icons/insert_drive_file.svg';
import Close from 'src/assets/icons/close.svg';
import * as classes from './fileInput.module.scss';

const FileInput = ({ files, setFiles, className, hidePhotoOption }) => {
  const [showCamera, setShowCamera] = useState(false);
  const hiddenFileInput = useRef(null);
  const [fileInputCanCapture, setFileInputCanCapture] = useState(false);

  // Don't detect this on first run to deal with server side rendering, and then only
  // run once since it won't change.
  useEffect(() => {
    const input = document.createElement('input');
    setFileInputCanCapture(input.capture !== undefined);
  }, []);

  return (
    <div className={className}>
      {files.map((file) => (
        <div className={classes.imagePreview} key={file.id}>
          <div className={classes.imagePreviewTitle}>
            <File className={classes.icon} />
            <div className={classes.filename}>{file.name}</div>
            <button type="button" className={classes.close}>
              <Close onClick={() => setFiles(without(files, file))} />
            </button>
          </div>
          {file.type.startsWith('image/') && (
            <LocalFileImage src={file} className={classes.imagePreviewImage} />
          )}
        </div>
      ))}

      <div className={classes.buttons}>
        {!hidePhotoOption && !fileInputCanCapture && (
          <button
            type="button"
            className={classnames('button', classes.button)}
            onClick={() => setShowCamera(true)}
          >
            <CameraIcon className={classes.icon} />
            Take a photo
          </button>
        )}
        <button
          type="button"
          className={classnames('button', classes.button)}
          onClick={() => hiddenFileInput.current.click()}
        >
          <Upload className={classes.icon} />
          Upload a file
        </button>
      </div>
      {showCamera && (
        <div className={classes.camera}>
          <Camera
            isFullscreen
            onTakePhotoAnimationDone={(dataUri) => {
              const blob = dataURItoBlob(dataUri);
              blob.name = 'Photo';
              blob.id = uuid();
              setFiles([...files, blob]);
              setShowCamera(false);
            }}
            onCameraError={() => {
              // eslint-disable-next-line no-alert
              alert(
                'There was an error accessing your camera. Please make sure you have an attached camera and grant the site permission to use it.',
              );
              setShowCamera(false);
            }}
          />
        </div>
      )}
      <input
        type="file"
        style={{ display: 'none' }}
        accept="image/*,application/pdf"
        ref={hiddenFileInput}
        multiple
        onChange={(e) => {
          const newFiles = Array.from(e.target.files).map((f) => {
            f.id = uuid();
            return f;
          });
          setFiles([...files, ...newFiles]);

          // Reset the file input so you can re-add the same file. Otherwise you get weird unpredictable
          // behavior where sometimes it lets you upload and sometimes it ignores (because it's already
          // selected).
          e.target.value = '';
        }}
      />
    </div>
  );
};

export default FileInput;
